export default "__VITE_ASSET__DmtsG4FV__"